<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    위험작업 목록-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot" /> 위험작업 목록
        </h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-3 flex items-center"
            v-for="checkbox in form.inspectionList"
            v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    장비 정보-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot" /> 장비 정보
        </h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 업체명</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_1"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 운전원</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_2"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">운전원 면허번호</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_3"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 종류(기종 및 모델명)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_4"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 형식 및 규격(정격하중)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_5"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 지지방법 및 기타</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_6"
          class="w-full flex-1"
        />
      </div>
    </div>

    <!--    현장개요-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot" /> 현장개요
        </h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">현장주소</div>
        <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>
        <company-selector
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_1"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">공사금액</div>
        <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
        <comma-input
          v-else
          :readonly="board.readonly"
          class="w-full flex-1"
          placeholder=""
          v-model="form.inputC_2"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">공사기간</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputC_3 }} ~ {{ form.inputC_4 }}
        </p>
        <div v-else class="flex-1 flex items-center">
          <date-selector
            class="w-full flex-1"
            v-model="form.inputC_3"
            :readonly="board.readonly"
          />
          <p class="px-2">~</p>
          <date-selector
            class="w-full flex-1"
            v-model="form.inputC_4"
            :readonly="board.readonly"
          />
        </div>
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">공종명</div>
        <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_5"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업장소</div>
        <p v-if="isPrint" class="print-input">{{ form.inputC_6 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_6"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업기간</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputC_7 }} ~ {{ form.inputC_8 }}
        </p>
        <div v-else class="flex-1 flex items-center">
          <date-selector
            class="w-full flex-1"
            v-model="form.inputC_7"
            :readonly="board.readonly"
          />
          <p class="px-2">~</p>
          <date-selector
            class="w-full flex-1"
            v-model="form.inputC_8"
            :readonly="board.readonly"
          />
        </div>
      </div>

      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          상세 작업내용
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_9 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_9"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          작업순서
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_10 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_10"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          지장물 현황
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_11 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_11"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          인원투입계획
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_12 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_12"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          자재투입계획
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_13 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_13"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          장비투입계획
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_14 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_14"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          유해·위험요인 및 재해형태
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_15 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_15"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          안전대책
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_16 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_16"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">
          사고 시 비상 대응체계
        </div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_17 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_17"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업 계획도 및 관련 도면 첨부</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputC_18.fileName }}
        </p>
        <file-uploader
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_18"
          class="w-full flex-1"
        />
      </div>
    </div>

    <!--    목록표 -->
    <table-inspect-division
      class="mt-2"
      v-for="(inspection, indexRows) in form.inspectionList"
      v-bind:key="inspection.id"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspection.title"
      :list="inspection.list"
      v-if="inspection.check"
      @update-list-check="(param1, param2, param3)=>{
        updateListCheck(indexRows,param1,param2,param3
        )}"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'

export default {
  components: {
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (!this.form || !this.form.inspectionList || this.form.inspectionList.length === 0) {
          this.form.inspectionList = this.inspectionList
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectionList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
    updateListCheck (indexList, indexTableRows, indexRows, text) {
      this.form.inspectionList[indexList].list[indexTableRows].list[indexRows].is_checked = text
    },
  },
  computed: {
    getInspectionListTitle () {
      let result = ''
      for (const data of this.form.inspectionList) {
        if (data.check) {
          result += `${data.label} , `
        }
      }

      if (result.length > 0) {
        result = result.substring(0, result.length - 2)
      }
      return result
    },
    inspectionList () {
      return [
        {
          id: 1,
          label: '굴착작업(굴착면의 높이가 2m 이상)',
          check: false,
          title: '사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)',
          list: [
            {
              headerTitle: '사전조사 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '형상·지질 및 지층의 상태 ',
                  is_checked: ''
                },
                {
                  id: 2,
                  type: '나',
                  label: '균열·함수(含水)·용수 및 동결의 유무 또는 상태 ',
                  is_checked: ''
                },
                {
                  id: 3,
                  type: '다',
                  label: '매설물 등의 유무 또는 상태 ',
                  is_checked: ''
                },
                {
                  id: 4,
                  type: '라',
                  label: '지반의 지하수위 상태 ',
                  is_checked: '',
                },
              ]
            },
            {
              headerTitle: '작업계획서 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '굴착방법 및 순서, 토사 반출 방법',
                  is_checked: ''
                },
                {
                  id: 2,
                  type: '나',
                  label: '필요한 인원 및 장비 사용계획',
                  is_checked: ''
                },
                {
                  id: 3,
                  type: '다',
                  label: '매설물 등에 대한 이설·보호대책',
                  is_checked: ''
                },
                {
                  id: 4,
                  type: '라',
                  label: '현장 내 연락방법 및 신호방법',
                  is_checked: '',
                },
                {
                  id: 5,
                  type: '마',
                  label: '흙막이 지보공 설치방법 및 계측계획',
                  is_checked: '',
                },
                {
                  id: 6,
                  type: '바',
                  label: '작업지휘자의 배치계획',
                  is_checked: '',
                },
                {
                  id: 7,
                  type: '사',
                  label: '그 밖에 안전·보건에 관련된 사항',
                  is_checked: '',
                },
              ]
            }
          ]
        },
        {
          id: 2,
          label: '터널굴착작업',
          check: false,
          title: '사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)',
          list: [
            {
              headerTitle: '사전조사 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '보링(boring) 등 적절한 방법으로 낙반·출수(出水) 및 가스폭발 등으로 인한 근로자의 위험을 방지하기 위하여 미리 지형·지질 및 지층상태를 조사',
                  is_checked: ''
                },
              ]
            },
            {
              headerTitle: '작업계획서 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '굴착의 방법',
                  is_checked: ''
                },
                {
                  id: 2,
                  type: '나',
                  label: '터널지보공 및 복공(覆工)의 시공방법과 용수(湧水)의 처리방법 ',
                  is_checked: ''
                },
                {
                  id: 3,
                  type: '다',
                  label: '환기 또는 조명시설을 설치할 때에는 그 방법',
                  is_checked: ''
                },
              ]
            }
          ]
        },
        {
          id: 3,
          label: '교량작업',
          check: false,
          title: '사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)',
          list: [
            {
              headerTitle: '작업계획서 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '작업 방법 및 순서',
                  is_checked: ''
                },
              ]
            }
          ]
        },
        {
          id: 4,
          label: '채석작업',
          check: false,
          title: '사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)',
          list: [
            {
              headerTitle: '사전조사 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '지반의 붕괴·굴착기계의 굴러 떨어짐 등에 의한 근로자에게 발생할 위험을 방지하기 위한 해당 작업장의 지형·지질 및 지층의 상태',
                  is_checked: ''
                },
              ]
            },
            {
              headerTitle: '작업계획서 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '노천굴착과 갱내굴착의 구별 및 채석방법 ',
                  is_checked: ''
                },
                {
                  id: 2,
                  type: '나',
                  label: '굴착면의 높이와 기울기 ',
                  is_checked: ''
                },
                {
                  id: 3,
                  type: '다',
                  label: '굴착면 소단(小段: 비탈면의 경사를 완화시키기 위해 중간에 좁은 폭으로 설치하는 평탄한 부분)의 위치와 넓이',
                  is_checked: ''
                },
                {
                  id: 4,
                  type: '라',
                  label: '갱내에서의 낙반 및 붕괴방지 방법',
                  is_checked: '',
                },
                {
                  id: 5,
                  type: '마',
                  label: '발파방법',
                  is_checked: '',
                },
                {
                  id: 6,
                  type: '바',
                  label: '암석의 분할방법 ',
                  is_checked: '',
                },
                {
                  id: 7,
                  type: '사',
                  label: '암석의 가공장소',
                  is_checked: '',
                },
                {
                  id: 8,
                  type: '아',
                  label: '사용하는 굴착기계·분할기계·적재기계 또는 운반기계(이하 "굴착기계등"이라 한다)의 종류 및 성능 ',
                  is_checked: '',
                },
                {
                  id: 9,
                  type: '자',
                  label: '토석 또는 암석의 적재 및 운반방법과 운반경로',
                  is_checked: '',
                },
                {
                  id: 10,
                  type: '차',
                  label: '표토 또는 용수(湧水)의 처리방법',
                  is_checked: '',
                },
              ]
            }
          ]
        },
        {
          id: 5,
          label: '건물 등의 해체작업',
          check: false,
          title: '사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)',
          list: [
            {
              headerTitle: '사전조사 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '해체건물 등의 구조, 주변 상황 등',
                  is_checked: ''
                },
              ]
            },
            {
              headerTitle: '작업계획서 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: '가',
                  label: '해체의 방법 및 해체 순서도면',
                  is_checked: ''
                },
                {
                  id: 2,
                  type: '나',
                  label: '가설설비·방호설비·환기설비 및 살수·방화설비 등의 방법',
                  is_checked: ''
                },
                {
                  id: 3,
                  type: '다',
                  label: '현장 내 연락방법 ',
                  is_checked: ''
                },
                {
                  id: 4,
                  type: '라',
                  label: '해체물의 처분계획',
                  is_checked: ''
                },
                {
                  id: 5,
                  type: '마',
                  label: '해체작업용 기계·기구 등의 작업계획서 ',
                  is_checked: '',
                },
                {
                  id: 6,
                  type: '바',
                  label: '해체작업용 화약류 등의 사용계획서 ',
                  is_checked: '',
                },
                {
                  id: 7,
                  type: '사',
                  label: '그 밖에 안전·보건에 관련된 사항',
                  is_checked: '',
                },
              ]
            }
          ]
        },
      ]
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        inspectionList: [],
        typeTitleList: [],

        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',
        inputB_5: '',
        inputB_6: '',

        inputC_1: '',
        inputC_2: '',
        inputC_3: '',
        inputC_4: '',
        inputC_5: '',
        inputC_6: '',
        inputC_7: '',
        inputC_8: '',
        inputC_9: '',
        inputC_10: '',
        inputC_11: '',
        inputC_12: '',
        inputC_13: '',
        inputC_14: '',
        inputC_15: '',
        inputC_16: '',
        inputC_17: '',
        inputC_18: {}, // file

        fileList: [],
      },
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
